import { Component } from '@angular/core';
import { HideAlert } from '@app/core/actions/alert';
import { AlertMessage } from '@app/core/models/alert/alert-message';
import { ErrorMessage } from '@app/core/models/alert/error-message';
import * as fromRoot from '@app/reducer';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'pcs-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent {
  alerts$: Observable<AlertMessage[]>;

  constructor(private store: Store<fromRoot.State>) {
    this.alerts$ = store.pipe(select(fromRoot.getAlerts));
  }

  shouldAutoClose(alert: AlertMessage) {
    return !(alert instanceof ErrorMessage);
  }

  onRemoved(alert) {
    this.store.dispatch(new HideAlert(alert));
  }

}

